import { render, staticRenderFns } from "./TmNotifications.vue?vue&type=template&id=332fc705&"
import script from "./TmNotifications.vue?vue&type=script&lang=js&"
export * from "./TmNotifications.vue?vue&type=script&lang=js&"
import style0 from "./TmNotifications.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports